import React, { setGlobal } from 'reactn';
import ReactDOM from 'react-dom';
import ConfirmForm from './ConfirmForm';

(async () => {
    const appContainer = document.querySelector('[data-confirmation-form]');

    await setGlobal({
        searchResult: {},
        roomNumber: [],
        confirming: false,
    });

    if (appContainer) {
        ReactDOM.render(<ConfirmForm />, appContainer);
    }
})();
